import React from 'react';
import BlockContent from '@sanity/block-content-to-react';

export default ({
	content
}) => (
		<div className="row align--center">
			<div className="col c10--md c7--lg">
				{renderContent(content)}
			</div>
		</div>
	);

const blockRenderer = props => {
	const { style = 'normal' } = props.node;

	if (/^h\d/.test(style)) {
		let className = '';
		const level = style.replace(/[^\d]/g, '');
		switch (level) {
			case '1':
				className = 'domaine--medium-large mt1 mb2';
				break;
			case '2':
				className = 'sans--large mt2';
				break;
		}
		
		return React.createElement(style, { className }, props.children);
	}
	
	return React.createElement(style, { className: 'sans--medium color--gray-text db mb1 mt1' }, props.children);
};

const linkRenderer = props => {
	return (
		<a className="link--gray-black" href={props.mark.url}>{props.children}</a>
	);
};

function renderContent(content) {
	let results = [];
	const block = <BlockContent blocks={content} serializers={{ types: { block: blockRenderer }, marks: { link: linkRenderer } }} />;
	results.push(block);

	return results;
}